import auth from './auth/authReducer'
import posts from './posts/postsReducer'

export default {
    auth,
    posts
}